import _ from '../../core/utils'
import MAP_CASES_CONFIG from "./config"
import API from '../api'
import chunk from 'lodash.chunk'
import mapboxgl from 'mapbox-gl'
mapboxgl.accessToken = 'pk.eyJ1IjoiYWRyaWFhbG9zIiwiYSI6ImNrNXoybGpqdTBweGszbG5qNmEwNzJ1dzAifQ.6mtLHsiBciOXdPVRMY3fuQ'


class MapCasesClass {
    constructor() {
        this.DOM = {
            el: MAP_CASES_CONFIG.el,
            map: null,
            markers: null,
            cards: null
        }
        
        this.markerIco = String
        this.linkIco = String
        this.mapbox = null
        this.markers = []
        this.endpoint = MAP_CASES_CONFIG.endpoint

        this.DOM.el ? this.init() : null
    }

    // INIT
    init() {
        this._mapSet()
        this._mapRender()
        this._controlsNavigation()
    }

    // MAP: set
    _mapSet() {
        // Map DOM
        this.DOM.map = _.select( '.map', this.DOM.el )

        // Get icos
        this.markerIco = this.DOM.map.getAttribute( 'data-marker-ico' )
        this.linkIco = this.DOM.map.getAttribute( 'data-link-ico' )

        console.log( this )
    }
    // MAP: render
    _mapRender() {
        this.mapbox = new mapboxgl.Map({
            container: this.DOM.map,
            style: 'mapbox://styles/mapbox/light-v10',
            center: [ 0, 0 ],
            zoom: 2
        });
        
        this.mapbox.on( 'load', () => {
            this._markersGet()
        })

        this._zoomDisable()
        
    }

    // CONTROLS
    // CONTROLS: navigation
    _controlsNavigation() {
        this.mapbox.addControl( new mapboxgl.NavigationControl() )
    }

    // ZOOM
    // ZOOM: disable
    _zoomDisable() {
        this.mapbox.scrollZoom.disable()
    }

    // MARKER
    // MARKER: add
    _markersGet() {

        API.get( this.endpoint )
        .then( ( response ) => {
            if ( response.data.success ) {
                let cases = response.data.cases
                cases.forEach( ( cStudy ) => { this._markerAdd( cStudy ) } )

                _.addClass( this.DOM.el, 'is--loaded' )
                this.DOM.countrySelector ? _.removeClass( this.DOM.countrySelector, 'disabled' ) : null
            }
        })
        .catch( ( error ) => {
            console.log( error )
        })
    }

    _markerAdd( cStudy ) {
        const marker = document.createElement( 'div' )
        marker.className = 'fl__marker'
        marker.setAttribute( 'data-id', cStudy.id )
        marker.setAttribute( 'data-country', cStudy.country )
        marker.setAttribute( 'data-longitude', cStudy.longitude )
        marker.setAttribute( 'data-latitude', cStudy.latitude )
        marker.innerHTML = `<span style="background-image:url(${this.markerIco})"></span>`

        const pic = cStudy.pic != null ? `<img src="${cStudy.pic}" class="objectfit"/>` : ''
        const popup = new mapboxgl.Popup()
        .setHTML(`
        <div class="fl__map-popup">
            <a href="${cStudy.url}" class="pic">
                ${pic}
            </a>
            <div class="text">
                <span>${cStudy.posted}</span>
                <a href="${cStudy.url}">${cStudy.title}</a>
            </div>
            <a href="${cStudy.url}" class="lnk"><img src="${this.linkIco}"/></a>
        </div>
        `)
        .setMaxWidth('300')

        this.markers.push ( 
            new mapboxgl.Marker( marker )
            .setLngLat( [ cStudy.longitude, cStudy.latitude ] )
            .setPopup( popup )
            .addTo( this.mapbox )
        )
    }

    
}

const MAP_CASES = new MapCasesClass()
export default MAP_CASES